import { render, staticRenderFns } from "./jbxx1.vue?vue&type=template&id=a52d2678&scoped=true&"
import script from "./jbxx1.vue?vue&type=script&lang=js&"
export * from "./jbxx1.vue?vue&type=script&lang=js&"
import style0 from "./jbxx1.vue?vue&type=style&index=0&id=a52d2678&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52d2678",
  null
  
)

export default component.exports